import React, { useState, useEffect } from "react";
import "./AdminProjectInfo.css";
import { Alert, Button, Modal } from "react-bootstrap";
import AddOrder from "./addOrder";
import {
  handleDelete,
  handlePreviewOption,
  handleProjectCompleted,
} from "./adminFunction";
import FilesOption from "./filesOption";
import { useDispatch } from "react-redux";
import { statusColors } from "../componentDashboard/mainComponents/projectFunction";

export default function AdminProjectInfo({ projectList, setProjectList }) {
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");

  const [addOrder, setAddOrder] = useState(false);
  const [projecDelete, setProjectDelete] = useState(false);
  const [projecComplete, setProjecComplete] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [siteAddress, setSiteAddress] = useState("");
  const [customer, setCustomer] = useState("");
  const [pagination, setPagination] = useState({
    start: 1,
    end: 5,
  });

  const handlePagination = (value) => {
    if (value === "right") {
      setPagination({
        start: pagination.start + 5,
        end: pagination.end + 5,
      });
    } else if (value === "left") {
      setPagination({
        start: pagination.start - 5,
        end: pagination.end - 5,
      });
    } else {
      setPagination(pagination);
    }
  };

  const [list, setList] = useState([
    {
      id: 1,
      structureType: "Select",
      articleName: "",
      structureImage: "",
      totalStructure: 0,
      price: 0,
    },
  ]);

  // const placeOrder = async (e) => {
  //   e.target.disabled = true;
  //   if (siteName === "" || siteAddress === "" || customer === "") {
  //     alert("Please fill all the fields");
  //     e.target.disabled = false;
  //     return;
  //   }

  //   // Get Date in DD-MM-YYYY format
  //   const date = new Date();
  //   const dd = String(date.getDate()).padStart(2, "0");
  //   const mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
  //   const yyyy = date.getFullYear();
  //   const today = dd + "-" + mm + "-" + yyyy;

  //   try {
  //     const authId = sessionStorage.getItem("authId");
  //     const projectCollectionRef = collection(db, "projects");
  //     const projectData = {
  //       adminId: authId,
  //       designer: sessionStorage.getItem("fullName"),
  //       value: {
  //         siteName: siteName,
  //         siteAddress: {
  //           value: siteAddress,
  //         },
  //         customerName: customer,
  //       },
  //       quantityInfo: {
  //         roofNo: 0,
  //         allRoof: false,
  //         roofData: [
  //           {
  //             structureType: "Multiple",
  //             multipleStructure: list,
  //           },
  //         ],
  //       },
  //       statusInfo: {
  //         status: "Pending",
  //         updateDate: today,
  //       },
  //     };
  //     await addDoc(projectCollectionRef, projectData);
  //     setProjectList([projectData, ...projectList]);
  //   } catch (error) {
  //     console.log(error);
  //     alert("Something went wrong");
  //     e.target.disabled = false;
  //     return;
  //   }

  //   alert("Order Placed Successfully");
  //   setAddOrder(false);
  //   setSiteName("");
  //   setSiteAddress("");
  //   setCustomer("");

  //   e.target.disabled = false;
  //   return;
  // };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const [project, setProject] = useState("");
  const [projectName, setProjectName] = useState("");
  const [alert, setAlert] = useState(false);
  const [status, setStatus] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const handleShow = (item) => {
    setProject(item);
    setProjectName(item.siteName);
  };
  useEffect(() => {
    if (alert || status) {
      const timeout = setTimeout(() => {
        setAlert(false);
        setStatus(false);
      }, 3000);

      return () => clearTimeout(timeout);
    }
  }, [alert, status]);

  return (
    <>
      {/* {loader ? (
        <Loader backgroundColor={"white"}></Loader>
      ) : ( */}
      <div className="adminProjectInfo">
        <div className="ProjectListHeader">
          <form>
            <i className="bi bi-search"></i>
            <input
              type="text"
              placeholder="Search by Date/Customer Name"
              value={searchTerm}
              onChange={handleSearchInputChange}
            />
          </form>
          {projectList.length > 0 &&
            pagination.end + 1 - pagination.start < projectList.length && (
              <div className="pagination">
                <h6>
                  Projects on page: {pagination.start} -{" "}
                  {pagination.end >= projectList.length
                    ? projectList.length
                    : pagination.end}{" "}
                  of {projectList.length}
                </h6>
                <i
                  className={
                    pagination.start === 1
                      ? `bi bi-chevron-double-left disable`
                      : `bi bi-chevron-double-left`
                  }
                  onClick={() => {
                    pagination.start === 1
                      ? handlePagination("")
                      : handlePagination("left");
                  }}
                ></i>
                <i
                  className={
                    pagination.end >= projectList.length
                      ? `bi bi-chevron-double-right disable`
                      : `bi bi-chevron-double-right`
                  }
                  onClick={() => {
                    pagination.end >= projectList.length
                      ? handlePagination("")
                      : handlePagination("right");
                  }}
                ></i>
              </div>
            )}
          {/* <div>
              <button
                className="addProjectBtn"
                onClick={() => {
                  setAddOrder(true);
                }}
              >
                <i
                  className="bi bi-plus-lg"
                  style={{
                    color: "rgb(39, 50, 106)",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                />
                Add Order
              </button>
            </div> */}
        </div>
        {projectList.length > 0 ? (
          <div className="projectList">
            <div style={{ overflowX: "scroll", width: "100%" }}>
              <table>
                <thead>
                  <tr>
                    <th>Site Name</th>
                    <th style={{ width: "350px" }}>Site Address</th>
                    <th>Customer Name</th>
                    <th>Mounting Structure</th>
                    <th>Designed By</th>
                    <th>Status</th>
                    <th>Files</th>
                    <th style={{ textAlign: "center" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {projectList
                    .slice(pagination.start - 1, pagination.end)
                    .map((item, index) => (
                      <tr key={index}>
                        <td> {item.value.siteName} </td>
                        <td> {item.value.siteAddress.value} </td>
                        <td> {item.value.customerName} </td>
                        <td> {item.value.selectionType} Structure</td>
                        <td> {item.designer} </td>
                        {/* <td> {item.statusInfo.updateDate} </td> */}
                        <td>
                          <span
                            className="badge"
                            style={{
                              backgroundColor: `${
                                statusColors[item.statusInfo.status]
                              }`,
                            }}
                          >
                            {item.statusInfo.status}
                          </span>
                          <br />
                          <span className="badge-under">
                            Last Updated On {item.statusInfo.updateDate}
                          </span>
                        </td>
                        <td
                          className="file"
                          onClick={() =>
                            handlePreviewOption(dispatch, item, setShowPreview)
                          }
                        >
                          <i className="bi bi-eye-fill"></i> Preview
                        </td>

                        <td>
                          <span>
                            {(item.statusInfo.status === "Draft" ||
                              item.statusInfo.status === "Pending") && (
                              <div className="actions">
                                <svg
                                  onClick={() => {
                                    setProjecComplete(true);
                                    handleShow(item);
                                  }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21V3C24 1.34315 22.6569 0 21 0H3ZM18.0455 7.4545C18.4794 7.88846 18.4848 8.58872 18.0615 9.02921L12.0731 16.5146C12.0645 16.5254 12.0553 16.5357 12.0455 16.5455C11.6061 16.9848 10.8938 16.9848 10.4545 16.5455L6.48482 12.5758C6.04548 12.1365 6.04548 11.4242 6.48482 10.9848C6.92416 10.5455 7.63647 10.5455 8.07581 10.9848L11.2161 14.1251L16.4247 7.48816C16.4339 7.47635 16.4439 7.46511 16.4545 7.4545C16.8938 7.01517 17.6061 7.01517 18.0455 7.4545Z"
                                    fill="#28A745"
                                  />
                                </svg>
                                <svg
                                  onClick={() => {
                                    setProjectDelete(true);
                                    handleShow(item);
                                  }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M3 0C1.34315 0 0 1.34315 0 3V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21V3C24 1.34315 22.6569 0 21 0H3ZM8.03033 6.96967L12 10.9393L15.9697 6.96967C16.2626 6.67678 16.7374 6.67678 17.0303 6.96967C17.3232 7.26256 17.3232 7.73744 17.0303 8.03033L13.0607 12L17.0303 15.9697C17.3232 16.2626 17.3232 16.7374 17.0303 17.0303C16.7374 17.3232 16.2626 17.3232 15.9697 17.0303L12 13.0607L8.03033 17.0303C7.73744 17.3232 7.26256 17.3232 6.96967 17.0303C6.67678 16.7374 6.67678 16.2626 6.96967 15.9697L10.9393 12L6.96967 8.03033C6.67678 7.73744 6.67678 7.26256 6.96967 6.96967C7.26256 6.67678 7.73744 6.67678 8.03033 6.96967Z"
                                    fill="#DC3545"
                                  />
                                </svg>
                              </div>
                            )}
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          <div className="noProject">
            <img src="./images/Logos/Group.svg" alt="No Project yet"></img>
            <h2>You don't have any projects right now</h2>
          </div>
        )}
      </div>
      {/* )} */}

      <Modal
        show={addOrder}
        onHide={() => {
          setAddOrder(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="addOrderModel"
      >
        <Modal.Header closeButton>
          <Modal.Title className="title">Add Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-pair">
            <label className="label-name">Site Name</label>
            <input
              className="simple-inp"
              placeholder="Site name"
              value={siteName}
              onChange={(e) => setSiteName(e.target.value)}
            />
          </div>
          <div className="input-pair">
            <label className="label-name">Site Address</label>
            <textarea
              style={{ height: "64px", paddingTop: "8px" }}
              className="simple-inp"
              placeholder="Amet minim mollit non deserunt ullamco est sit aliqua dolor do dolor do "
              value={siteAddress}
              onChange={(e) => setSiteAddress(e.target.value)}
            />
          </div>
          <div className="input-pair">
            <label className="label-name">Customer Name</label>
            <input
              className="simple-inp"
              placeholder="Customer Name"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
            />
          </div>
          {/* Create a table like project list but here we've only three columns */}
          <AddOrder setList={setList} list={list}></AddOrder>
        </Modal.Body>
        <Modal.Footer className="addProfileModelFooter">
          <Button
            className="button"
            variant="secondary"
            onClick={() => {
              setAddOrder(false);
            }}
          >
            Close
          </Button>
          <Button 
          // onClick={placeOrder} 
          className="button" variant="primary">
            Add Order
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={projecDelete}
        onHide={() => {
          setProjectDelete(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="addProjectModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="title">Delete Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="projecDelete">
            Are you sure you want to delete this project? <br />
            <br />
            <span style={{ color: "red", fontSize: "12px" }}>
              *All details will be lost and can not be recovered
            </span>
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{ justifyContent: "end", gap: "8px" }}
          className="addProfileModelFooter"
        >
          <Button
            className="delButton"
            variant="secondary"
            onClick={() => {
              setProjectDelete(false);
            }}
          >
            Discard
          </Button>
          <Button
            className="delButton"
            variant="primary"
            onClick={() =>
              handleDelete(project, setProjectList, setProjectDelete, setAlert)
            }
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={projecComplete}
        onHide={() => {
          setProjecComplete(false);
        }}
        backdrop="static"
        keyboard={false}
        centered
        className="addProjectModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="title">Updated Proposal Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="projecDelete">
            If the project proposal has been finalized and accepted by the
            client, would you like to update the project status to 'Completed'?
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{ justifyContent: "end", gap: "8px" }}
          className="addProfileModelFooter"
        >
          <Button
            className="delButton"
            variant="secondary"
            onClick={() => {
              setProjecComplete(false);
            }}
          >
            Discard
          </Button>
          <Button
            className="delButton"
            variant="primary"
            onClick={() =>
              handleProjectCompleted(
                project,
                projectList,
                setProjectList,
                setProjecComplete,
                setStatus
              )
            }
          >
            Completed
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Report/BOQ View Option */}
      <Modal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        backdrop="static"
        keyboard={false}
        centered
        className="addProjectModal actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title className="title">Files View Option</Modal.Title>
        </Modal.Header>
        <Modal.Body className="previewOption">
          <FilesOption></FilesOption>

          {/* <div className="button-pair">
            <button
              className="closeButton"
              onClick={() => setShowPreview(false)}
            >
              Close
            </button>
            <button
              className="nextButton"
              onClick={() => {
                handlePreview();
              }}
            >
              Preview Report
            </button>
          </div> */}
        </Modal.Body>
      </Modal>

      {alert && (
        <Alert
          variant="success"
          onClose={() => setAlert(false)}
          dismissible
          className="popupMessage"
        >
          Your requested project {projectName} deleted successfully!
        </Alert>
      )}
      {status && (
        <Alert
          variant="success"
          onClose={() => setAlert(false)}
          dismissible
          className="popupMessage"
        >
          Your requested project {projectName} status updated successfully!
        </Alert>
      )}
    </>
  );
}

// const deleteImages = async () => {
//   const electricalImageUrl = roofInfo.electricalImageUrl
//     ? roofInfo.electricalImageUrl
//     : "";
//   const structureImageUrl = roofInfo.structureImageUrl
//     ? roofInfo.structureImageUrl
//     : "";
//   const storage = getStorage();
//   const electricalImageName = electricalImageUrl
//     .split("%2F")[1]
//     .split("?")[0];
//   const structureImageName = structureImageUrl.split("%2F")[1].split("?")[0];
//   const electricalImageRef = ref(storage, `images/${electricalImageName}`);
//   const structureImageRef = ref(storage, `images/${structureImageName}`);
//   try {
//     if (roofInfo.electricalImageUrl) await deleteObject(electricalImageRef);
//     if (roofInfo.structureImageUrl) await deleteObject(structureImageRef);
//     console.log("Images deleted successfully");
//   } catch (error) {
//     console.log(error);
//   }
// };

// const [projectRef, setProjectRef] = useState(null);
// const deleteProject = async (e) => {
//   e.target.disabled = true;
//   // First delete the electrical and structure image from storage in images folder whose links are present as roofInfo.electricalImageUrl and roofInfo.structureImageUrl

//   const collectionRef = collection(db, "projects");
//   console.log("projectRef", projectRef);
//   const q = query(
//     collectionRef,
//     where("siteName", "==", projectRef.siteName),
//     where("siteAddress", "==", projectRef.siteAddress),
//     where("customerName", "==", projectRef.customerName),
//     where("adminId", "==", projectRef.adminId)
//   );
//   try {
//     await deleteImages();
//     const querySnapshot = await getDocs(q);
//     querySnapshot.forEach(async (doc) => {
//       await deleteDoc(doc.ref);
//       console.log("Document successfully deleted!");
//     });
//     alert("Project Deleted Successfully");
//     setProjectList(
//       projectList.filter(
//         (item) =>
//           !(
//             item.siteName === projectRef.siteName &&
//             item.siteAddress === projectRef.siteAddress &&
//             item.customerName === projectRef.customerName &&
//             item.mountingStructure === projectRef.mountingStructure &&
//             item.adminId === projectRef.adminId
//           )
//       )
//     );
//     setProjectDelete(false);
//     setProjectRef(null);
//   } catch (error) {
//     console.log(error);
//     alert("Something went wrong");
//   }
//   e.target.disabled = false;
// };

/* <td className="files">
                          <div
                            className="file"
                            onClick={() => handleBOQ(item, dispatch, setBoq)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                            >
                              <path
                                d="M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5ZM8.5 5C8.5 4.72386 8.27614 4.5 8 4.5C7.72386 4.5 7.5 4.72386 7.5 5V10.7929L5.35355 8.64645C5.15829 8.45118 4.84171 8.45118 4.64645 8.64645C4.45118 8.84171 4.45118 9.15829 4.64645 9.35355L7.64645 12.3536C7.84171 12.5488 8.15829 12.5488 8.35355 12.3536L11.3536 9.35355C11.5488 9.15829 11.5488 8.84171 11.3536 8.64645C11.1583 8.45118 10.8417 8.45118 10.6464 8.64645L8.5 10.7929V5Z"
                                fill="#072A40"
                              />
                            </svg>
                            <span>BOQ</span>
                          </div>
                          <div
                            className="file"
                            onClick={() =>
                              handleInvoice(item, dispatch, setInvoice)
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="16"
                              height="17"
                              viewBox="0 0 16 17"
                              fill="none"
                            >
                              <path
                                d="M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5ZM8.5 5C8.5 4.72386 8.27614 4.5 8 4.5C7.72386 4.5 7.5 4.72386 7.5 5V10.7929L5.35355 8.64645C5.15829 8.45118 4.84171 8.45118 4.64645 8.64645C4.45118 8.84171 4.45118 9.15829 4.64645 9.35355L7.64645 12.3536C7.84171 12.5488 8.15829 12.5488 8.35355 12.3536L11.3536 9.35355C11.5488 9.15829 11.5488 8.84171 11.3536 8.64645C11.1583 8.45118 10.8417 8.45118 10.6464 8.64645L8.5 10.7929V5Z"
                                fill="#072A40"
                              />
                            </svg>
                            <span>Invoice</span>
                          </div>
                          <a
                            // href=""
                            style={
                              !item.inverterInfo
                                ? { pointerEvents: "none", opacity: "0.5" }
                                : {}
                            }
                            target="_blank"
                          >
                            <div
                              className="file"
                              onClick={() => showFeatureOptions(item)}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  d="M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5ZM8.5 5C8.5 4.72386 8.27614 4.5 8 4.5C7.72386 4.5 7.5 4.72386 7.5 5V10.7929L5.35355 8.64645C5.15829 8.45118 4.84171 8.45118 4.64645 8.64645C4.45118 8.84171 4.45118 9.15829 4.64645 9.35355L7.64645 12.3536C7.84171 12.5488 8.15829 12.5488 8.35355 12.3536L11.3536 9.35355C11.5488 9.15829 11.5488 8.84171 11.3536 8.64645C11.1583 8.45118 10.8417 8.45118 10.6464 8.64645L8.5 10.7929V5Z"
                                  fill="#072A40"
                                />
                              </svg>
                              <span>Report</span>
                            </div>
                          </a>
                        </td> */
